module.exports = __webpack_public_path__ + "img/banner2.b7fb17c0.png";